import React, { useEffect, useRef } from 'react';
import { FaRobot } from 'react-icons/fa';

const CoPilotTab = () => {
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    if (!scriptLoadedRef.current) {
      const script = document.createElement('script');
      script.src = 'https://d3gir378nh3g9k.cloudfront.net/lex-web-ui-loader.min.js';
      script.async = true;
      script.onload = () => {
        const loader = new window.ChatBotUiLoader.IframeLoader({
          baseUrl: 'https://d3gir378nh3g9k.cloudfront.net/',
          shouldLoadMinDeps: true
        });

        loader.load().catch((err) => console.error(err));
      };

      document.body.appendChild(script);
      scriptLoadedRef.current = true;
    }
  }, []);

  return (
    <div className="p-6 h-[calc(100vh-100px)] bg-gray-50 rounded shadow-lg">
      <div className="flex items-center space-x-4 mb-6">
        <FaRobot className="text-2xl text-purple-600" />
        <h1 className="text-2xl font-bold text-purple-800">Call Analytics CoPilot</h1>
      </div>

      <div className="bg-white border rounded-lg p-6 shadow text-gray-700 space-y-4">
        <p className="text-lg">
          👋 Welcome to your <strong>AI-powered CoPilot</strong>. You can ask questions like:
        </p>
        <ul className="list-disc list-inside pl-4 text-sm space-y-1">
          <li>What is the sentiment of the last call?</li>
          <li>Did the agent mention a payment arrangement?</li>
          <li>Summarize the dispute resolution conversation.</li>
          <li>Are there any red flags in the customer responses?</li>
        </ul>
        <p className="text-sm text-gray-500 italic">
          The CoPilot window is anchored at the bottom right. You can interact with it anytime.
        </p>
      </div>
    </div>
  );
};

export default CoPilotTab;

